import React, { useEffect, useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function TestimonialsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const headerReveal = useScrollReveal({
    threshold: 0.2
  });
  const cardsReveal = useScrollReveal({
    threshold: 0.1
  });
  const testimonials = [{
    text: "I actually sat through my entire quiet time this morning. For the first time in years, I read my devotional without checking my phone, without my mind wandering to my to-do list, without that restless feeling that I should be doing something else. I cried. Not from sadness from relief. This is who I've been trying to be.",
    author: 'Sarah M., Mom of 3',
    verified: true,
    rating: 5
  }, {
    text: "My kids noticed before I did. My daughter said, 'Mommy, you're not yelling as much anymore.' That hit me harder than any review could. I'm not a different person.. I'm finally the mom I always was underneath all that overwhelm.",
    author: 'Rachel T., Homeschool Mom',
    verified: true,
    rating: 5
  }, {
    text: "I stopped apologizing to God for being distracted during prayer. I used to feel so guilty like my scattered mind meant I was a bad Christian. Now I can actually BE with Him. Present. Focused. It's changed everything about my faith walk.",
    author: "Jennifer L., Women's Ministry Leader",
    verified: true,
    rating: 5
  }, {
    text: "I was skeptical. I'd tried everything. Ashwagandha. Magnesium. L-theanine. Adderall (which I hated). Planners. Apps. 'Just pray harder.' Nothing worked long-term. This is the first thing that actually supports the WHOLE problem the focus AND the calm AND the emotional steadiness. Week three, and I'm still consistent. That's never happened.",
    author: 'Amanda K., Working Mom',
    verified: true,
    rating: 5
  }, {
    text: "I finished something. Start to finish. Without abandoning it halfway through. I have 14 half-read books on my nightstand. Three unfinished Bible studies. A closet organization project from 2019. Last week, I sat down to write thank-you cards for my small group and I finished them. All of them. In one sitting. I know that sounds small. But if you're like me, you know it's not small at all. It's everything.",
    author: 'Amanda T.',
    verified: true,
    rating: 5
  }, {
    text: "My husband asked what changed. He said I seemed 'softer.' Less on edge. Less likely to snap when he asks a simple question at the wrong time. I didn't realize how much my overwhelm was affecting our marriage until it lifted. We actually had a calm conversation last night — no defensiveness, no me feeling attacked by everything. Just... talking. Like we used to before kids and chaos took over.",
    author: 'Brittany S., Married 11 Years',
    verified: true,
    rating: 5
  }];
  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Items per slide: 2 on mobile, 3 on desktop
  const itemsPerSlide = isMobile ? 2 : 3;
  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);
  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(timer);
  }, [totalSlides]);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % totalSlides);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + totalSlides) % totalSlides);
  };
  const visibleTestimonials = testimonials.slice(currentSlide * itemsPerSlide, currentSlide * itemsPerSlide + itemsPerSlide);
  return <section className="w-full bg-[#2d4a3a] py-16 lg:py-24 relative overflow-hidden" data-id="element-512">
      {/* Animated Wave Background */}
      <div className="absolute inset-0 opacity-10" data-id="element-513">
        <svg className="w-full h-full" viewBox="0 0 1440 320" preserveAspectRatio="none" data-id="element-514">
          <path fill="currentColor" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" data-id="element-515">
            <animate attributeName="d" dur="10s" repeatCount="indefinite" values="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                      M0,160L48,144C96,128,192,96,288,96C384,96,480,128,576,144C672,160,768,160,864,144C960,128,1056,96,1152,96C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                      M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" data-id="element-516" />
          </path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10" data-id="element-517">
        {/* Section Header */}
        <div ref={headerReveal.ref} className={`text-center mb-12 transition-all duration-1000 ${headerReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-518">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-519">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 fill-[#d4af37] text-[#d4af37] animate-pulse" style={{
            animationDelay: `${i * 0.1}s`
          }} data-id="element-520" />)}
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-521">
            Join 1,000,000+ Customers Who Love Faith & Fig
          </h2>
          <p className="text-white/80 text-lg" data-id="element-522">
            Real Christian women. Real results. Real peace.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative" data-id="element-523">
          <div ref={cardsReveal.ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-524">
            {visibleTestimonials.map((testimonial, index) => <div key={index} className={`bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 ${cardsReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} style={{
            transitionDelay: `${index * 150}ms`,
            transitionDuration: '700ms'
          }} data-id="element-525">
                <div className="flex items-center gap-1 mb-4" data-id="element-526">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#d4af37] text-[#d4af37]" data-id="element-527" />)}
                </div>
                <p className="text-gray-700 leading-relaxed mb-4 text-sm" data-id="element-528">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center justify-between" data-id="element-529">
                  <p className="font-semibold text-[#2d4a3a] text-sm" data-id="element-530">
                    {testimonial.author}
                  </p>
                  {testimonial.verified && <span className="text-xs text-[#496f58] font-medium" data-id="element-531">
                      ✓ Verified Customer
                    </span>}
                </div>
              </div>)}
          </div>

          {/* Carousel Controls */}
          <div className="flex items-center justify-center gap-4" data-id="element-532">
            <button onClick={prevSlide} className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 text-white flex items-center justify-center transition-all" aria-label="Previous testimonials" data-id="element-533">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-534" />
            </button>

            {/* Dots Indicator */}
            <div className="flex gap-2" data-id="element-535">
              {Array.from({
              length: totalSlides
            }).map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-white w-8' : 'bg-white/40'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-536" />)}
            </div>

            <button onClick={nextSlide} className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 text-white flex items-center justify-center transition-all" aria-label="Next testimonials" data-id="element-537">
              <ChevronRightIcon className="w-5 h-5" data-id="element-538" />
            </button>
          </div>
        </div>

        {/* Trust Badges */}
        
      </div>
    </section>;
}